export default {
  h1: {
    fontWeight: 800,
    fontSize: 35,
    fontFamily: "'Poppins', sans-serif"
  },
  h2: {
    fontWeight: 600,
    fontSize: 30,
    fontFamily: "'Poppins', sans-serif"
  },
  h3: {
    fontWeight: 500,
    fontSize: 30,
    fontFamily: "'Poppins', sans-serif"
  },
  h4: {
    fontWeight: 400,
    fontSize: 20,
    fontFamily: "'Poppins', sans-serif"
  },
  h5: {
    fontWeight: 300,
    fontSize: 18,
    fontFamily: "'Poppins', sans-serif"
  },
  h6: {
    fontWeight: 300,
    fontSize: 14,
    fontFamily: "'Poppins', sans-serif"
  },
  h7: {
    fontWeight: 300,
    fontSize: 16,
    fontFamily: "'Poppins', sans-serif"
  },
  overline: {
    fontWeight: 500,
    fontFamily: "'Poppins', sans-serif"
  },
  button: {
    textTransform: "capitalize",
    borderRadius: 27,
    fontFamily: "'Poppins', sans-serif"
  },
  body1: {
    fontSize: 12,
    fontFamily: "'Poppins', sans-serif"
    
  },
};
